import gql from 'graphql-tag'

export const famCoverImages = gql`
  fragment famCoverImages on CoverImages {
    alt
    desktop
    mobile
  }
`
